import { render } from "./bookmarkCategoryList.vue?vue&type=template&id=e080cfe4"
import script from "./bookmarkCategoryList.vue?vue&type=script&lang=js"
export * from "./bookmarkCategoryList.vue?vue&type=script&lang=js"

import "./bookmarkCategoryList.vue?vue&type=style&index=0&id=e080cfe4&lscoped=true&lang=css"
script.render = render

export default script